"use client";
import { getHSLAString } from "@aichat/aichat-lib";
import { AssistantAvatarWithBg } from "../assistant-avatar";
import GrowShrinkLoader from "../grow-shrink-loader";
import { useWebWidgetConfig } from "../web-widget/use-web-widget-config";

// @hidden
export default function MessageLoading({
  avatarVariant,
  customUrl,
  brandHSLAString,
}: {
  avatarVariant?: "light" | "dark";
  customUrl?: string;
  brandHSLAString?: string;
}) {
  const { brandColor, isThemeSleek } = useWebWidgetConfig();
  const brandColorHSLALight = getHSLAString({ ...brandColor, a: 0.2 });
  const brandColorHSLAVeryLight = getHSLAString({ ...brandColor, a: 0.1 });
  return (
    <div
      className="p-4 flex gap-2 items-center w-fit max-w-[374px] bg-background border border-secondary rounded-xl shadow-[0px_1px_2px_0px_#0000000D] "
      style={
        isThemeSleek
          ? {
              background: `linear-gradient(to right, ${brandColorHSLAVeryLight}, ${brandColorHSLALight})`,
            }
          : undefined
      }
    >
      <div className="shrink-0 ">
        <AssistantAvatarWithBg
          brandHSLAString={brandHSLAString}
          containerProps={{
            className: "size-6 rounded-lg",
          }}
          avatarProps={{
            className: "size-4",
            variant: avatarVariant,
            customUrl,
          }}
        />
      </div>
      <GrowShrinkLoader isThemeSleek={isThemeSleek} />
    </div>
  );
}
